<template>
  <div id="list">
    <div class="content" v-for="item in calist" :key="item.id">
      <div class="content-title">
        <div class="icon">
          <i class="iconfont" v-html="item.icon"></i>
        </div>
        <router-link tag="span" :to="'/list/' + item.id">{{item.title}}</router-link>
      </div>
      <div class="category">
        <ul>
          <router-link tag="li" :to="'/goods/' + citem.id" v-for="(citem, index) in item.classifyList" :key="index" class="detail border">{{citem.title}}</router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryList',
  props: {
    calist: Array
  }
}
</script>

<style scoped>
#list{ margin-bottom: 58px;}
.category{ text-align: center; line-height: 40px; margin-top: 15px;}
.category ul{ display: flex; flex-wrap: wrap; list-style-type: none; margin-left: 10px;}
.detail{ width: 24%; height: 40px; font-size: 12px; color: #737373;}
.content-title{ padding-top: 11px; margin-left: 10px; display: flex;}
.content-title span{ margin-left: 7px; color: #666666; font-size: 14px; line-height: 23px;}
.icon{ height: 23px; width: 23px; color: #fff; text-align: center; border-radius: 50%;}
.icon .iconfont{ font-size: 13px; line-height: 23px; color: #fff;}
.content:nth-child(1) .content-title .icon{ background-color: rgb(255, 137, 53); box-shadow: 2px 2px 1px rgb(255, 209, 176, 0.7);}
.content:nth-child(2) .content-title .icon{ background-color: rgb(239, 46, 101); box-shadow: 2px 2px 1px rgb(248, 173, 194, 0.7);}
.content:nth-child(3) .content-title .icon{ background-color: rgb(23, 195, 173); box-shadow: 2px 2px 1px rgb(177, 237, 229, 0.7);}
.content:nth-child(4) .content-title .icon{ background-color: rgb(228, 208, 47); box-shadow: 2px 2px 1px rgb(241, 228, 158, 0.7);}
.content:nth-child(5) .content-title .icon{ background-color: rgb(255, 137, 53); box-shadow: 2px 2px 1px rgb(255, 209, 176, 0.7);}
.content:nth-child(6) .content-title .icon{ background-color: rgb(239, 46, 101); box-shadow: 2px 2px 1px rgb(248, 173, 194, 0.7);}
.content:nth-child(7) .content-title .icon{ background-color: rgb(23, 195, 173); box-shadow: 2px 2px 1px rgb(177, 237, 229, 0.7);}
.content:nth-child(8) .content-title .icon{ background-color: rgb(228, 208, 47); box-shadow: 2px 2px 1px rgb(241, 228, 158, 0.7);}
.content:nth-child(9) .content-title .icon{ background-color: rgb(228, 208, 47); box-shadow: 2px 2px 1px rgb(241, 228, 158, 0.7);}
.content-last{ margin-bottom: 70px;}
body >>> #vueg-background{ background: #fff;}
</style>



// WEBPACK FOOTER //
// src/pages/category/components/List.vue